import { atom } from "jotai";

export const courseFilterAtom = atom<string[]>([]);
